import "./App.css";
import React from "react";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/pages/Home";
import Services from "./components/pages/Services";
import Contact from "./components/pages/Contact";
import Footer from "./components/Footer";
import Reel from "./components/pages/Reel";
import Railway from "./components/pages/Railway";
import Swinternship from "./components/pages/Swinternship";
import Techfpga from "./components/pages/Techfpga";
import Rsgroup from "./components/pages/Rsgroup";
import Peone from "./components/pages/Pe01";
import Petwo from "./components/pages/Pe02";
import Pethree from "./components/pages/Pe03";
import Pefour from "./components/pages/Pe04";
import Pefive from "./components/pages/Pe05";
import Photography from "./components/pages/Photograpy";
import Pesix from "./components/pages/Pe06";
import Wrapper from "./components/Wrapper";

function App() {
  return (
    <>
      <Router>
        <Wrapper />
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/reel" element={<Reel />} />
          <Route path="/railway" element={<Railway />} />
          <Route path="/swinternship" element={<Swinternship />} />
          <Route path="/techfpga" element={<Techfpga />} />
          <Route path="/rsgroup" element={<Rsgroup />} />
          <Route path="/pe01" element={<Peone />} />
          <Route path="/pe02" element={<Petwo />} />
          <Route path="/pe03" element={<Pethree />} />
          <Route path="/pe04" element={<Pefour />} />
          <Route path="/pe05" element={<Pefive />} />
          <Route path="/pe06" element={<Pesix />} />
          <Route path="/photography" element={<Photography />} />
        </Routes>
        <Footer />
        <Wrapper />
      </Router>
    </>
  );
}

export default App;
